import { mapGetters  } from 'vuex'
import {enterStatus} from '@utils'
export const enterInfo = {
    computed:{
        ...mapGetters({
            enterInfo:'getEnterInfo'
        }),
        //未提交入驻
        UNCOMMITTED(){
            return this.enterInfo && enterStatus.UNCOMMITTED == this.enterInfo.enterStatus;
        },
        //发起申请（草稿状态）
        TOAUDIT(){
            return this.enterInfo && enterStatus.TOAUDIT == this.enterInfo.enterStatus;
        },
        //审核中
        AUDITING(){
            return this.enterInfo && enterStatus.AUDITING == this.enterInfo.enterStatus;
        },
        //审核驳回—待修改
        ['REFUSE_MODIFY'](){
            return this.enterInfo && enterStatus.REFUSE_MODIFY == this.enterInfo.enterStatus;
        },
        //审核驳回—暂不合作
        ['REFUSE_TRANSITORY'](){
            return this.enterInfo && enterStatus.REFUSE_TRANSITORY == this.enterInfo.enterStatus;
        },
        //审核通过
        NOBIND(){
            return this.enterInfo && enterStatus.NOBIND == this.enterInfo.enterStatus;
        },
        //已入驻
        BIND(){
            return this.enterInfo && enterStatus.BIND == this.enterInfo.enterStatus;
        }
    }
}